var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{ref:"",staticClass:"b2b-grid__icon material-icons",on:{"click":_vm.expandRow}},[_vm._v(" add_box ")])])}
var staticRenderFns = []

export { render, staticRenderFns }